import axios from 'axios';
import { property } from 'lodash';

import { buildApiV2Url } from './utils/apiUtils';
import { generateApiError } from './utils/apiErrorMessages';
import { mapSurveyFromJsonApiModel } from './dataMapper/surveyDataMapper';

import { SURVEY_TYPE_COLLECTION_PATH } from './config/EntityCollectionPathMap';

export default (surveyId, templateId) =>
  axios
    .post(buildApiV2Url(`${SURVEY_TYPE_COLLECTION_PATH}/${surveyId}/load`), {
      template_id: templateId,
    })
    .then(property('data'))
    .then(mapSurveyFromJsonApiModel)
    .catch(generateApiError());
